import { render, staticRenderFns } from "./FilesField.vue?vue&type=template&id=2f743556&scoped=true&"
import script from "./FilesField.vue?vue&type=script&lang=js&"
export * from "./FilesField.vue?vue&type=script&lang=js&"
import style0 from "./FilesField.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FilesField.vue?vue&type=style&index=1&id=2f743556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f743556",
  null
  
)

export default component.exports
import {QTree,QBtn,QBtnDropdown,QList,QItem,QItemSection,QIcon,QMenu,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTree,QBtn,QBtnDropdown,QList,QItem,QItemSection,QIcon,QMenu,QSeparator}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
